import * as React from 'react';
import { findDOMNode } from 'react-dom';
import styled, { StyledComponentClass } from 'styled-components';
import { Size } from '../../types';
import { colors, sizes } from '../../styles';
import { Dropdown } from './';
import { DropdownProps } from './props';

export interface Props extends DropdownProps {
  triggerIconSize?: Size;
}

class FlyoutMenu extends React.Component<Props, {}> {
  public static defaultProps: Props = {
    triggerIconSize: 'sm',
  };

  private el: HTMLElement = null;

  public componentDidMount() {
    if (!this.el) {
      return;
    }

    const {
      bottom = 0,
      height = 0,
      right = 0,
      top = 0,
      width = 0,
    } = this.el.getBoundingClientRect();

    const {
      innerHeight,
      innerWidth,
      // IE11 does not support scrollX or scrollY :(
      pageXOffset,
      pageYOffset,
    } = window;

    const parent = this.el.parentElement;

    const { left: parentLeft = 0, top: parentTop = 0 } =
      (parent && parent.getBoundingClientRect()) || {};

    const OFFSET_TOP = 5;
    const OFFSET_LEFT = 30;

    const triggerIsAtBottom =
      bottom > innerHeight && pageYOffset + top > height;
    const triggerIsAtRight =
      right > innerWidth && pageXOffset + parentLeft > width;

    const contentPositionTop = triggerIsAtBottom
      ? parentTop - height + OFFSET_TOP
      : parentTop + OFFSET_TOP;

    const contentPositionLeft = triggerIsAtRight
      ? parentLeft - width + OFFSET_LEFT
      : parentLeft + OFFSET_LEFT;

    this.el.style.top = `${Math.floor(contentPositionTop)}px`;
    this.el.style.left = `${Math.floor(contentPositionLeft)}px`;
  }

  public render() {
    const { className, triggerIconSize, ...props } = this.props;

    return (
      <div id="flyout-menu" className={className} ref={el => (this.el = el)}>
        <Dropdown {...props} />
      </div>
    );
  }
}

export default styled(FlyoutMenu)`
  border-radius: 6px;
  box-shadow: 0 1px 3px 0 ${colors.grey200}, 0 4px 16px 0 ${colors.grey100},
    0 0 0 1px ${colors.grey50};
  height: ${p => p.listOptions.length * 44}px;
  position: fixed;

  &.up {
    bottom: 0;
  }

  .list-item {
    justify-content: center; /* override */
    padding: 1em 2em; /* override */

    :not(:last-child) {
      box-shadow: 0 1px 0 0 ${colors.grey100}; /* override */
    }

    white-space: nowrap;
  }
`;
